document.addEventListener("DOMContentLoaded", function(e) {

	//a bool to indicate whether or not the menu is active
	let menu_active = false;

	//fetch all menu items
	var menu_items = document.getElementsByClassName("menu-item");

	//fetch the mega menu dropdown
	var menu = document.getElementById("section-119-2160279");

	//loop through each menu item and add a hover event listener
	for(let i = 0; i < menu_items.length; i++) {
		menu_items[i].addEventListener("mouseover", trigger_nav, false);
	}

	//add the closing event listener to the menu item
	menu.addEventListener("mouseleave", close_nav, false);

	function trigger_nav(e) {

		//if this is a breakpoint where the mega menu is available
		if(window.matchMedia("(min-width: 1451px)").matches) {

			//fetch the target event (from the listener)
			let menu_item = e.target;

			//if we've incorrectly got an A tag
			if(menu_item.tagName == "A") {

				//get its parent (LI)
				menu_item = menu_item.parentNode;
			}

			//if the menu is currently inactive and this is the New Cars menu item
			if(!menu_active && menu_item.classList.contains('menu-item-2160966')) {

				//get the menu items position from the top of the screen
				let top_offset = menu_item.offsetTop + menu_item.offsetHeight;
		
				//add that offset to the mega menu
				menu.style.top = top_offset + 'px';

				//toggle it
				document.body.classList.add('megamenu-active');

				//indicate that it's open
				menu_active = true;
			} else if(menu_active && !menu_item.classList.contains('menu-item-2160966') && menu.querySelector('.' + (menu_item.classList.value).replace(/ /g, '.')) === null) { //otherwise if the menu is active, and this is not the New Cars menu item, and the mega menu doesn't contain the menu item
				
				//close it
				close_nav();
			}	
		}
	}

	function close_nav() {

		//if this is a breakpoint where the mega menu is available
		if(window.matchMedia("(min-width: 1451px)").matches) {

			//hide the mega menu
			document.body.classList.remove('megamenu-active');

			//when the closing animation is complete (300ms)
			setTimeout(function() {

				//remove the offset
				menu.style.top = '0px';

				//indicate that it's closed
				menu_active = false;
			}, 300);
		}
	}
});